import CompanyCard from "components/screener/cards/CompanyCard";
import RealEstateFundCard from "components/screener/cards/RealEstateFundCard";
import FileSearchingDuff from "components/screener/FileSearchingDuff";
import type { IIssuerObject } from "lib/algolia/types/assets";
import type { InfiniteHitsProvided } from "react-instantsearch-core";
import { connectInfiniteHits } from "react-instantsearch-core";

const ScreenerHits = connectInfiniteHits<InfiniteHitsProvided<IIssuerObject>, IIssuerObject>(
  ({ hits, hasMore, refineNext }) => {
    const assets = hits.filter(Boolean);

    if (assets.length === 0) {
      return (
        <div className="flex flex-col items-center justify-between space-y-10 font-aeonik">
          <FileSearchingDuff />

          <div className="space-y-1 text-center">
            <h4 className="text-xl font-medium tracking-wider text-slate-700">Não encontramos nenhum resultado.</h4>
            <p className="text-sm font-normal tracking-wider text-slate-500">
              Altere os filtros da sua busca e tente novamente.
            </p>
          </div>
        </div>
      );
    }

    return (
      <div className="space-y-7">
        <div className="relative grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {assets.map((asset) => {
            if (
              asset.type === "BRAZILIAN_COMPANY" ||
              asset.type === "AMERICAN_COMPANY" ||
              asset.type === "AMERICAN_REIT"
            ) {
              return <CompanyCard key={asset.objectID} company={asset} />;
            }

            if (asset.type === "BRAZILIAN_REAL_ESTATE_FUND") {
              return <RealEstateFundCard key={asset.objectID} fund={asset} />;
            }

            return null;
          })}
        </div>

        {hasMore && (
          <div className="text-center">
            <button
              type="button"
              onClick={() => refineNext()}
              className="font-aeonik text-base font-medium tracking-wide text-blue-600 hover:underline"
            >
              Ver mais ativos
            </button>
          </div>
        )}
      </div>
    );
  },
);

export default ScreenerHits;
